import { Injectable } from '@angular/core';
import { BaseService } from '../../../../core/base/base.service';
import { HttpClient } from '@angular/common/http';
import { MetrikTypeHoldingModel } from '../../../../core/models/metrik-type-holding.model';
import { EstablishmentModel } from '../../../../core/models/establishment.model';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetrikTypeHoldingService extends BaseService<MetrikTypeHoldingModel> {
  defaultSort = 'technicalIdentifier';
  defaultSortOrder = 'asc';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'metrik-type-holding', authService);
  }

  checkDependencies(metrikTypeHoldingModel: MetrikTypeHoldingModel) {
    return this.http.post<ObjectApiInterface<any>>(
      `${this.baseUrlApi}/checkDependencies/${metrikTypeHoldingModel._id}`,
      {},
    );
  }

  // function called by a generic system, don't remove it :
  changeAndArchiveGeneric(_id: string, body: any) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndArchiveGeneric/${_id}`, body).pipe(
      map(x => {
        // this._entity.next(x.data);
        return x;
      }),
    );
  }
}
